import { Component, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CopyrightComponent } from '../copyright/copyright.component';

@Component({
  selector: 'lv-password-reset-token-expired',
  templateUrl: 'password-reset-token-expired.component.html',
  styleUrls: ['password-reset-token-expired.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RouterModule, TranslateModule, CopyrightComponent]
})
export class PasswordResetTokenExpiredComponent {}
